import { CollapsibleFilter } from './collapsible-filter';
import { LocationFilterDrawer } from './location-filter-drawer';
import { LocationFilterPopover } from './location-filter-popover';

type LocationFilterProps = {
  className?: string;
  variant?: 'mobile' | 'desktop';
  defaultOpen?: boolean;
};

export const LocationFilter = ({
  className,
  variant = 'mobile',
  defaultOpen = false,
}: LocationFilterProps) => {
  return (
    <CollapsibleFilter
      title='Location'
      defaultOpen={defaultOpen}
      className={className}
    >
      {variant === 'mobile' ? (
        <LocationFilterDrawer />
      ) : (
        <LocationFilterPopover />
      )}
    </CollapsibleFilter>
  );
};
